import { render, staticRenderFns } from "./xppen-csae.vue?vue&type=template&id=62bd81cc&scoped=true&"
import script from "./xppen-csae.vue?vue&type=script&lang=js&"
export * from "./xppen-csae.vue?vue&type=script&lang=js&"
import style0 from "./xppen-csae.vue?vue&type=style&index=0&id=62bd81cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd81cc",
  null
  
)

export default component.exports